export const questions = [
    {
        question: "როდის ტარდება საბაზისო კურსები და რამდენ ხანს გრძელდება?",
        answer: "საბაზისო მომზადების კურსები ტარდება გაზაფხულზე და შემოდგომით. კურსი გრძელდება დაახლ. 2-2,5 თვე (სასწავლო რაზმის მიხედვით) და მოიცავს 20-22 საველე და თეორულ სწავლებას. თეორიული სწავლება ტარდება სამუშაო დღეების მეორე ნახევარში, ხოლო საველე ძირითადად კვირას."
    },
    {
        question: "როგორია კურსის სტანდარტული საველე-სასწავლო დღე?",
        answer: "მეთაურები და ახალწვეულები იკრიბებიან წინასწარ დათქმულ დროს და საზოგადოებრივი ტრანსპორტით (ან თავდაცვის სამინისტროს მანქანებით) გადაადგილდებიან სწავლების ჩატარების ადგილისკენ. გასვლა სრულდება დაახ. 1700 სთ-ზე. თუ ახალწვეულს გადაუდებელი საქმე აქვს, შეუძლია დატოვოს სწავლება და გაცდენად არ ჩაეთვლება."
    },
    {
        question: "არის თუ არა ასაკობრივი შეზღუდვა?",
        answer: "ლეგიონის საბაზისო კურსზე ჩაწერა შეიძლება 14 წლის ასაკიდან."
    },
    {
        question: "სად არის ლეგიონის ფილიალები?",
        answer: "ლეგიონის ორგანიზაციები არსებობენ თბილისში, გორში, ბათუმში, ტყიბულში, ამბროლაურში, ახალციხესა და სიღნაღში. შემოდგომით კურსები ჩატარდება რამდენიმე დამატებით ლოკაციაზე."
    },
    {
        question: "გაიცემა თუ არა ეკიპირება?",
        answer: "თავდაცვის სამინისტროს დახმარებით პერიოდულად გაიცემა პირადი ეკიპირების კომპლექტი (კეპი, მაისური, ქურთუკი, პიჯაკი, შარვალი და ფეხსაცმელი).\n" +
            "\n" +
            "კურსის მიმდინარეობისას შეძლებისდაგვარად გაიცემა იარაღის მულაჟი, ზურგჩანთა, საწვიმარი და ქვეშსაგები. ვისაც აქვს სტრაიკბოლის სათამაშო იარაღი, შეუძლია წამოიღოს გამორთულ მდგომარეობაში."
    },
    {
        question: "რა უნდა ვიქონიოთ თან გასვლაზე?",
        answer: "კურსის განმავლობაში სამხედრო ფორმის ტარება სავალდებულო არაა.\n" +
            "\n" +
            "სასურველია თუ ახალწვეული თან იქონიებს შემდეგ ნივთებს: ქუდი, სამხედრო ფორმა (ან მუქი ფერის ტანსაცმელი), ზურგჩანთა (საკვების, წყლის და სათადარიგო ნივთების ჩასალაგებლად), საწვიმარი, სამხედრო ჩექმა (ან სქელძირიანი კედი/ბოტასი). თან უნდა ჰქონდეს საკვები და წყალი (მინ. 2 ლიტრი)."
    },
    {
        question: "არიან თუ არა კურსზე გოგოები?",
        answer: "დიახ. ლეგიონის წევრების მესამედზე მეტს გოგონები შეადგენენ, მათ შორის სამეთაურო შემადგენლობაში."
    },
    {
        question: "რას აკეთებენ კურსდამთავრებულები?",
        answer: "ლეგიონერები მონაწილეობენ ლეგიონის სექციების სწავლებებში, ლაშქრობებში და ღონისძიებებში. წევრობის ასაკი შეზღუდული არაა და მოქალაქეს ცხოვრების ბოლომდე შეუძლია იყო ლეგიონერი.\n" +
            "\n" +
            "ლეგიონერები ეწერებიან ძალოვან სტრუქტურებში, ნაწილი სამოქალაქოდ რჩება, მაგრამ არ იბნევა ექსტრემალურ სიტუაციაში და გადარჩენის უფრო მეტი შანსი აქვს, ვიდრე მოუმზადებელ მოქალაქეს. ნაწილი სხვას უზიარებს საკუთარ ცოდნას და გამოცდილებას მეთაურის, ინსტრუქტორის და დამხმარეს რანგში."
    },
    {
        question: "ვინ გაფინანსებთ?",
        answer: "ლეგიონი არ ფინანსდება სახელმწიფო ბიუჯეტიდან. მიმდინარე ხარჯებს ვფარავთ ლეგიონერები და გვეხმარებიან შემომწირველები.\n" +
            "\n" +
            "2016-2018 წლებში ლეგიონი პრეზიდენტის ადმინისტრაციის პატრონაჟის ქვეშ იმყოფებოდა და სარეზერვო ფონდიდან ფინანსდებოდა წელიწადში დაახლ. 30.000 ლარით, რაც ძირითადად იხარჯებოდა ეკიპირების და სახარჯო მასალის შესაძენად.\n" +
            "\n" +
            "2016 წლიდან ტრანსპორტირებაში გვეხმარება თავდაცვის სამინისტრო. 2020 წლიდან განსაკუთრებით გაღრმავდა ურთიერთობა, პერიოდულად გადმოგვეცემა ეკიპირება, ხდება დაშვება ბაზებზე და ა.შ."
    },
    {
        question: "ფოტოებზე იარაღი ჩანს და რა ტიპისაა?",
        answer: "სწავლებებში გამოიყენება იარაღის პლასტმასის მოდელები, რომლებიც ნაყიდია სათამაშოების მაღაზიაში და ხის მულაჟები, რომლებსაც თავად ლეგიონერები ამზადებენ. ჩვენ არ გაგვაჩნია ცეცხლსასროლი იარაღი და ვიცავთ კანონით გათვალისწინებულ ყველა რეგულაციას."
    },
    {
        question: "როგორია ფიზიკური დატვირთვები?",
        answer: "მსუბუქი და საშუალო დონის, საბაზისო მომზადების დროს ახალწვეულებს საშუალოდ 5-15 კმ-ს ფეხით გავლა უწევთ. ლეგიონში აქცენტი კეთდება განათლების მიღებაზე და დროს არ ვკარგავთ ფეხით ხანგრძლივ გადაადგილებაზე. საკუთარ ფიზიკურ მომზადებაზე თავად ლეგიონერმა უნდა იზრუნოს."
    },

]